import AxiosInstance from "service/axiosInstance";
import { isHttpSuccess } from "utils/functions";

interface FetchTagsOptions {
    value?: string;
    withRelationshipOnly?: boolean;
}

export const fetchTags = async (
    organisationId: string,
    options: FetchTagsOptions = {}
): Promise<any[]> => {
    try {
        const params: any = {
            organisation_id: organisationId,
            with_relationship: true,
        };

        if (options.value) {
            params.value = options.value;
        }

        const response = await AxiosInstance.get("/tags", { params });
        if (isHttpSuccess(response.status)) {
            return response.data?.data ?? [];
        }
        return [];
    } catch (error) {
        console.error("Networks: Error fetching tags:", error);
        return [];
    }
};

